import { render } from "./StructuredTableComponent.vue?vue&type=template&id=32197bdf&scoped=true"
import script from "./StructuredTableComponent.vue?vue&type=script&lang=js"
export * from "./StructuredTableComponent.vue?vue&type=script&lang=js"

import "./StructuredTableComponent.vue?vue&type=style&index=0&id=32197bdf&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3389461850/src/acx.portal/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32197bdf"]])

export default __exports__